import { Component } from '@angular/core';
import { AbstractCo2QuestionnaireDirective } from '../abstract-co2-questionnaire.directive';

@Component({
  selector: 'app-co2-questionnaire-material',
  templateUrl: './co2-questionnaire-material.component.html',
  styleUrls: ['./co2-questionnaire-material.component.scss'],
})
export class Co2QuestionnaireMaterialComponent extends AbstractCo2QuestionnaireDirective {}
